<template>
  <div style="width: 100%;height: 100%" draggable="false">
    <div ref="item" class="palette-item" draggable="false">
      <img :data-type="type" :data-extra="extra" :src="src">
    </div>
    <p style="width: 100%;text-align: center;font-size: 12px;margin-top: 5px; white-space: nowrap">{{ name }}</p>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    src: String,
    name: String,
    type: {
      type: String,
      default: () => 'img'
    },
    extra: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="less" scoped>
.palette-item {
  width: 100%;
  height: 100%;
  padding: 3px;
  margin: 0 auto;
  cursor: pointer;

  img {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  p {
    width: 100%;
    text-align: center;
    font-size: 12px;
  }
}
</style>
